<template>
  <div>
    <sidebar-right-side
      :uploadEndpoint="uploadEndpoint"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      :fieldStructure="dataStructure"
      :key="operation + formType"
      :endPoint="endPoint"
      :addionalData="filter"
      @addNew="(value) => addNew(value)"
      @updateRow="(value) => addNew(value)"
    />

    <vs-popup fullscreen title="Info" :active.sync="showPopupInfo">
      <show-info :key="curentRowId" />
    </vs-popup>

    <vs-popup fullscreen title="Select Items" :active.sync="showPopup">
      <selectable
        @input="(value) => insertDone(value)"
        :key="showPopup"
        endPoint="myCatalogues"
        :filterEndpoint="returnFilters()"
      />
    </vs-popup>

    <vs-popup fullscreen title="PDF Preview" :active.sync="showPdf">
      <vue-pdf :key="updateUrl" :sourceFile="updateUrl" />
    </vs-popup>

    <vs-popup fullscreen title="Image Preview" :active.sync="showImage">
      <div class="centerx"></div>
      <img :src="updateImageUrl" :sourceFile="updateImageUrl" />
    </vs-popup>

    <search
      v-if="dataStatructureReady"
      @submit="(data) => filterHandler(data)"
      @pdf="(data) => excelHandler(data)"
      @excel="(data) => excelHandler(data)"
    />
    <vs-table
      id="loader"
      class="vs-con-loading__container"
      :sst="true"
      @sort="handleSort"
      v-model="selected"
      @selected="handleSelected"
      max-items="3"
      :data="tableComputedData"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center" v-if="showAdd">
          <!-- ADD NEW -->
          <div
            v-if="showAddBtn"
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewData"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
          v-if="showAdd"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * per_page - (per_page - 1) }} -
              {{
                pageTotal - currentPage * per_page > 0
                  ? currentPage * per_page
                  : pageTotal
              }}
              of {{ totalData }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="per_page = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 50">
              <span>500</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <template v-for="(fName, indexTd) in dataStructure">
          <vs-th
            v-if="fName.showInTable == 'yes'"
            :sort-key="indexTd"
            :key="indexTd"
            >{{ fName.label }}</vs-th
          >
        </template>
        <vs-th v-if="showActionButton">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :state="data[indextr]['state']"
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <template v-for="(fName, indexTd) in dataStructure">
            <template v-if="fName.showInTable == 'yes'">
              <vs-td
                v-if="fName.type == 'aronSelect'"
                :data="data[indextr][indexTd]"
                :key="indexTd"
                >{{ decodeSelectValue(indextr, indexTd, fName.data) }}</vs-td
              >

              <vs-td
                v-else-if="fName.type == 'aronMultiSelect'"
                :data="data[indextr][indexTd]"
                :key="indexTd"
                >{{ decodeMultiSelectValue(indextr, indexTd) }}</vs-td
              >

              <vs-td
                v-else-if="fName.type == 'aronFile'"
                :data="data[indextr][indexTd]"
                :key="indexTd"
              >
                <div @click.stop="showFileOrImageHandler(data[indextr][indexTd])">
                  <!-- @click.stop="showFileOrImageHandler(data[indextr][indexTd])" -->
                  <!-- {{ baseURl + "/storage/" + data[indextr][indexTd] }} -->

                  <img
                    width="auto"
                    height="70px"
                    :src="showImageInRow(data[indextr][indexTd])"
                  />
                </div>
              </vs-td>

              <vs-td v-else :data="data[indextr][indexTd]" :key="indexTd">{{
                data[indextr][indexTd]
              }}</vs-td>
            </template>
          </template>

          <vs-td class="whitespace-no-wrap" v-if="showActionButton">
            <feather-icon
              v-if="showEditBtn"
              icon="EditIcon"
              svgClasses="w-5 h-5 hover:text-primary stroke-current"
              @click.stop="editData(tr)"
            />
            <feather-icon
              icon="TrashIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click.stop="deleteData(tr)"
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div>
      <vs-pagination :total="pageTotal" v-model="currentx" goto></vs-pagination>
    </div>
  </div>
</template>
  
<script>
import axios from "@/axios.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

//form type
import sidebarRightSide from "../dataViews/sidebarRightSide.vue";
import profile from "../dataViews/profile";
// import popup from "../dataViews/displayOptions/popup_fullscreen.vue";

import selectable from "../table/selectable.vue";

import { alertMixin } from "../../../mixin/alertMixin";
import { axiosMixin } from "../../../mixin/axiosMixin";
import { helperMixin } from "../../../mixin/helperMixin";
import { mapGetters } from "vuex";

import vuePdf from "../dataViews/vuepdf";
import search from "./search";
import showInfo from "./showPopupInfo";

export default {
  components: {
    sidebarRightSide,
    profile,
    selectable,
    vuePdf,
    search,
    showInfo,
  },
  mixins: [alertMixin, axiosMixin, helperMixin],
  data: () => ({
    showPopupInfo: false, //show details popup
    curentRowId: "", //this is use so that we can trigger a reload to show a popup for row info
    numPages: 3, //total number of pages for pdf preview
    thePdfSource: "", //use to display the PDF
    theImageSource: "", //use to display the IMAGES
    showPopup: false, //this is a form type. if true, the popup will show
    showPdf: false, //use for displaying files from table
    showImage: false, //use for displaying files from table
    operation: "add",
    dataStructure: {},
    tblData: [],
    selected: [],
    log: [],
    currentx: 1,
    pageTotal: 1,
    per_page: 10,
    sort_by: "id",
    sort_direction: "desc",
    totalData: 0,
    isMounted: false,
    //for sidebar form
    addNewDataSidebar: false,
    sidebarData: {},
    dataStatructureReady: false,
  }),
  props: {
    endPoint: {
      type: String,
    },
    uploadEndpoint: {
      type: String,
    },
    formType: {
      type: String,
    },
    filter: {
      type: Object,
      default() {
        return {};
      },
    },
    exportExcelEndpoint: {
      type: String,
      default: "exportExcel",
    },
    filterEndpoint: {
      type: String,
      default: "",
    },
    viewOnly: {
      type: Boolean,
    },
    showAddBtn: {
      type: Boolean,
      default: true,
    },
    showFilter: {
      type: Boolean,
      default: true,
    },
    showEditBtn: {
      type: Boolean,
      default: true,
    },
    showActionButton: {
      type: Boolean,
      default: true,
    },
    showCancelBtn: {
      type: Boolean,
      default: true,
    },
    editPage: {
      type: String,
      default: "",
    },
    previewPage: {
      type: String,
      default: "",
    },
  },
  watch: {
    currentx: function () {
      this.getData("from current x");
    },
    per_page: function () {
      this.getData("from perpage");
    },
  },
  computed: {
    ...mapGetters({
      getProfileId: "profile/getProfileId",
      getMainInfo: "profile/getMainInfo",
    }),
    baseURl() {
      return axios.defaults.baseURL;
    },
    currentPage() {
      if (this.isMounted) {
        return this.currentx;
      }
      return 0;
    },
    tableComputedData() {
      return this.tblData;
    },
    showAdd() {
      return !this.viewOnly;
    },
    updateUrl() {
      return this.thePdfSource;
    },
    updateImageUrl() {
      return this.theImageSource;
    },
  },
  methods: {
    showImageInRow(source) {
      var filename = this.getFileExtention(source);
      if (filename == "pdf") {
        return this.baseURl + "/storage/" + source;
      } else if (
        filename == "jpeg" ||
        filename == "jpg" ||
        filename == "png" ||
        filename == "gif"
      ) {
        return this.baseURl + "/storage/" + source;
      }
    },
    showFileOrImageHandler(source) {
      var filename = this.getFileExtention(source);
      if (filename == "pdf") {
        this.showPdf = true;
        this.thePdfSource = this.baseURl + "/storage/" + source;
      } else if (
        filename == "jpeg" ||
        filename == "jpg" ||
        filename == "png" ||
        filename == "gif"
      ) {
        this.showImage = true;
        this.theImageSource = this.baseURl + "/storage/" + source;
      }
    },
    returnFilters() {
      return {
        pkId: this.getMainInfo.prVendorId,
      };
    },
    startLoading() {
      this.$vs.loading({
        container: "#loader",
        scale: 0.6,
      });
    },
    closeLoading() {
      this.$vs.loading.close("#loader > .con-vs-loading");
    },
    decodeSelectValue(tr, td, options) {
      return this.decodeValueForSelect(options, this.tblData[tr][td]);
    },
    // decodeSelectValue(value,options) {
    //  return this.arrayOfObjectFind(options,value)[0].label;
    // },
    decodeMultiSelectValue(tr, td) {
      return this.flattenJsonStringArray(this.tblData[tr][td], "label");
    },
    addNew($val) {
      if (this.sort_direction == "asc") {
        var newTotalPage = Math.ceil((this.totalData + 1) / this.per_page);
        if (this.currentx != newTotalPage) {
          this.currentx = newTotalPage;
        } else {
          this.getData("add new");
        }
      } else {
        if (this.currentx == this.pageTotal) {
          this.getData("add new");
        } else {
          this.currentx = this.pageTotal;
        }
      }
    },
    filterHandler(data) {
      console.log("search:", data);

      this.filterData = data;
      this.addToObject(this.filter, {
        advanceFilter: this.filterData,
      });
      this.getData("advance filter");
    },
    excelHandler(data) {
      console.log(
        "exce:",
        axios.defaults.baseURL +
          "/" +
          this.endPoint +
          "_" +
          this.exportExcelEndpoint
      );
      //  window.open(axios.defaults.baseURL + this.endPoint + "_" + this.exportExcelEndpoint, "_blank");
      //add the filter data
      this.filterData = data;
      this.addToObject(this.filter, {
        advanceFilter: this.filterData,
      });
      //filterHandler(data);
      var params = "page=" + this.currentx + "&per_page=" + this.per_page;
      var sort =
        "&sort_by=" + this.sort_by + "&sort_direction=" + this.sort_direction;
      // this.aronPost(this.endPoint + "_" + this.exportExcelEndpoint, this.filter, params, sort)
      //   .then(response => {})
      //   .catch(error => {
      //     // this.decodeErrorFromAxios(error);
      //   });
      var myEndPoint = "/" + this.endPoint + "_" + this.exportExcelEndpoint;
      // axios
      //   .get("/" + this.endPoint + "_" + this.exportExcelEndpoint, {
      //     responseType: "arraybuffer",
      //     headers: {
      //       "Content-Type": "application/json",
      //       Accept: "application/pdf"
      //     }
      //   })
      //   .then(response => {
      //     const url = window.URL.createObjectURL(new Blob([response.data]));
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", "file.xlsx"); //or any other extension
      //     document.body.appendChild(link);
      //     link.click();
      //   })
      //   .catch(error => console.log(error));

      axios({
        method: "post",
        url: myEndPoint + "?".concat(params).concat(sort),
        data: this.filter,
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error));
    },
    deleteData(data) {
      this.aronDelete(this.endPoint, data.id, "Item Deleted!")
        .then((response) => {
          if (this.countObject(this.tblData) <= 0) {
            this.currentx = this.currentx - 1;
            if (this.currentx < 0) {
              this.currentx = 0;
            }
          } else {
            this.getData("delete");
          }
        })
        .catch((error) => {
          console.log("in elete error: ", error);
        });
    },
    handleSort(key, direction) {
      this.sort_by = key;
      this.sort_direction = direction;
      this.getData("from sort");
    },
    handleClick(type, index) {
      //console.log(this.tblData[index]);
    },
    insertDone(val) {
      this.showPopup = false;
      this.getData("insert");
    },
    handleSelected(tr) {
      this.curentRowId = tr.id;
      this.$store.dispatch("profile/setCurrentMainInfo", tr);
      this.$store.dispatch(
        "profile/setCurrentMainDataStructure",
        this.dataStructure
      );
      this.showPopupInfo = true;
    },
    getData(from) {
      this.startLoading();
      var params = "page=" + this.currentx + "&per_page=" + this.per_page;
      var sort =
        "&sort_by=" + this.sort_by + "&sort_direction=" + this.sort_direction;
      console.log("filterssssssss:", this.filter);
      if (this.countObject(this.filter) > 0) {
        console.log("filterEndpoint:", this.filterEndpoint);
        this.aronPost(this.filterEndpoint, this.filter, params, sort)
          .then((response) => {
            if (response.status == 200) {
              this.tblData = response.data.data;
              this.dataStructure = response.data.fields;

              this.setDataStructure();
              this.dataStatructureReady = true;

              this.totalData = response.data.meta.pagination.total;
              this.pageTotal = response.data.meta.pagination.total_pages;
            }

            this.closeLoading();
          })
          .catch((error) => {
            // this.decodeErrorFromAxios(error);
            this.closeLoading();
          });
      } else {
        this.aronGet(this.endPoint, params, sort)
          .then((response) => {
            this.tblData = response.data.data;
            this.dataStructure = response.data.fields;

            this.setDataStructure();
            this.dataStatructureReady = true;

            this.pageTotal = response.data.meta.pagination.total_pages;
            this.totalData = response.data.meta.pagination.total;

            this.closeLoading();
          })
          .catch((error) => {
            // this.decodeErrorFromAxios(error);
            this.closeLoading();
          });
      }
    },
    setDataStructure() {
      this.$store.dispatch("profile/setMainDataStructure", this.dataStructure);
    },
    editData(data) {
      //change the operation to update
      this.operation = "update";
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    addNewData() {
      if (this.formType == "sidebarRightSide") {
        this.sidebarData = {};
        this.toggleDataSidebar(true);
      } else if (this.formType == "profile") {
        this.$store.dispatch("profile/setMainInfo", {});
        this.$store.dispatch(
          "profile/setMainDataStructure",
          this.dataStructure
        );

        this.$router
          .push("/edit/" + this.endPoint + "/" + "new")
          .catch(() => {});
      } else if (this.formType == "popup") {
        this.showPopup = true;
      } else {
        this.$store.dispatch("profile/setMainInfo", {});
        this.$store.dispatch(
          "profile/setMainDataStructure",
          this.dataStructure
        );

        this.$router
          .push("/" + this.editPage + "/" + this.endPoint)
          .catch(() => {});
      }
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
  },
  created() {
    this.dataStatructureReady = false;
  },
  mounted() {
    this.isMounted = true;
    this.getData("created");
  },
};
</script>
<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>